import styled from 'styled-components'

export const AdsStatus = styled.p`
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
`

export const Label = styled.span`
  ${({ theme }) => theme.textStyles.montserratSm};
`

export const Status = styled.span`
  ${({ theme }) => theme.textStyles.montserratTextBaseBold};
  margin-left: 1rem;
`
